import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const activities = [
  {
    title: "Sochu Thinking Series",
    subtitle: "Series - 1",
    duration: "12 Books + Activities",
    img: "/thinking.png",
    slug: "pause-with-5-breaths",
  },
  {
    title: "Sochu Feeling Series",
    subtitle: "Series - 2",
    duration: "17 Books + Activities",
    img: "/feeling.png",
    slug: "finding-hope",
    disabled: true,
  },
  {
    title: "Sochu Doing Series",
    subtitle: "Series - 3",
    duration: "22 Books + Activities",
    img: "/doing.png",
    slug: "awareness",
    disabled: true,
  },
];

const SeriesScreen = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState("home");
  const [purchaseStatus, setPurchaseStatus] = useState(null); // To show purchase result

  const handleFooterClick = (page) => {
    setSelected(page);
    navigate(`/${page}`);
  };

  // Handle Appilix Purchase
  const handlePurchase = () => {
    // Check if appilix is available
    if (typeof window.appilix === 'undefined') {
      alert('Appilix is not available. Please open this in the Appilix app.');
      return;
    }

    // Step 01: Send purchase request to Appilix
    window.appilix.postMessage(JSON.stringify({
      type: "apple_iap_init",
      props: {
        product_id: "product1",
        product_type: "consumable"
      }
    }));

    console.log("Purchase request sent to Appilix...");

    // Step 03: Listen for response from Appilix
    window.appilix.onmessage = function(event) {
      console.log("App response:", event.data);
      
      try {
        const response = JSON.parse(event.data);
        
        // Step 02: Handle the purchase response
        if (response.type === "apple_iap_init") {
          if (response.response.status === true) {
            // Purchase successful
            console.log("Purchase successful!", response.response.product);
            setPurchaseStatus({
              success: true,
              message: "Purchase completed successfully!",
              product: response.response.product
            });
            
            // TODO: You can now unlock content, update user status, etc.
            // For example: navigate to success page or unlock the series
            
          } else {
            // Purchase failed
            console.log("Purchase failed:", response.response.message);
            setPurchaseStatus({
              success: false,
              message: response.response.message || "Purchase failed. Please try again."
            });
          }
        }
      } catch (error) {
        console.error("Error parsing response:", error);
        setPurchaseStatus({
          success: false,
          message: "Error processing purchase response."
        });
      }
      
      // Remove listener after receiving the first response
      window.appilix.onmessage = null;
    };
  };

  return (
    <div className="min-h-screen bg-white pt-6 px-4 pb-[100px]">
      {/* Logo */}
      <div className="flex justify-center mb-6">
        <img
          src="/newlogo1.jpeg"
          alt="Sochu Logo"
          className="w-[180px] md:w-[250px]"
        />
      </div>

      {/* Timeline Section */}
      <div className="relative max-w-md mx-auto">
        {/* Vertical line */}
        <div className="absolute left-5 top-0 h-full border-l-2 border-dotted border-gray-300 z-0"></div>

        {activities.map((item, idx) => (
          <div key={idx} className="relative flex items-start gap-3 mb-6 z-10">
            {/* Dot */}
            <div className="w-10 flex justify-center relative">
              <span
                className={`absolute top-1/2 -translate-y-1/2 w-3 h-3 rounded-full ${
                  idx === 0 ? "bg-[#e82829]" : "bg-white border border-gray-400"
                } block z-10`}
              ></span>
            </div>

            {/* Clickable Card */}
            <div
              onClick={() => {
                if (!item.disabled) navigate(`/learn/${item.slug}`);
              }}
              className={`flex-1 rounded-xl shadow-sm border p-5 flex items-center justify-between transition-transform ${
                item.disabled
                  ? "bg-gray-100 border-gray-200 opacity-60 cursor-not-allowed"
                  : "bg-white border-gray-200 hover:scale-[1.02] active:scale-[0.98] cursor-pointer"
              }`}
            >
              <div className="flex flex-col gap-1 max-w-[60%]">
                <div className="flex items-center gap-1 text-[15px] font-semibold">
                  <span>{item.title}</span>
                </div>
                <p className="text-sm text-gray-500">{item.subtitle}</p>
                <p className="text-sm text-gray-400">{item.duration}</p>
                {item.disabled && (
                  <p className="text-xs mt-1 text-green-500 font-semibold">
                    Coming Soon
                  </p>
                )}
                {item.people && (
                  <p className="text-sm text-indigo-500 mt-1">{item.people}</p>
                )}
              </div>
              <img
                src={item.img}
                alt={item.title}
                className="w-24 h-24 object-cover rounded-md"
                onError={(e) => (e.target.style.display = "none")}
              />
            </div>
          </div>
        ))}
      </div>

      {/* Purchase Button */}
      <div className="max-w-md mx-auto mb-6">
        <button 
          onClick={handlePurchase}
          className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 active:bg-blue-800 transition-colors"
        >
          Purchase Now
        </button>

        {/* Show purchase status */}
        {purchaseStatus && (
          <div className={`mt-4 p-4 rounded-lg ${
            purchaseStatus.success 
              ? 'bg-green-100 border border-green-400 text-green-700' 
              : 'bg-red-100 border border-red-400 text-red-700'
          }`}>
            <p className="font-semibold">
              {purchaseStatus.success ? '✓ Success!' : '✗ Failed'}
            </p>
            <p className="text-sm mt-1">{purchaseStatus.message}</p>
            {purchaseStatus.product && (
              <div className="mt-2 text-sm">
                <p><strong>Product:</strong> {purchaseStatus.product.title}</p>
                <p><strong>Price:</strong> {purchaseStatus.product.price}</p>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-0 left-0 right-0 bg-white shadow-md p-2 pt-3 z-50">
        <div className="flex justify-around items-center text-gray-600 pb-3">
          <button
            onClick={() => {
              const audio = new Audio("/sounds/click.mp3");
              audio.play();
              handleFooterClick("learn");
            }}
            className={`flex flex-col items-center ${
              selected === "home" ? "text-blue-600" : "text-gray-600"
            } transition-colors`}
          >
            <img
              src={
                selected === "learn"
                  ? "/sochumenuselectednew.png"
                  : "/sochumenuunselectednew.png"
              }
              alt="Broadcast"
              className="h-14 w-14"
            />
            <span className="text-xs">Learn</span>
          </button>

          <button
            onClick={() => {
              const audio = new Audio("/sounds/click.mp3");
              audio.play();
              handleFooterClick("leaderboard");
            }}
            className={`flex flex-col items-center ${
              selected === "leaderboard" ? "text-yellow-600" : "text-gray-600"
            } transition-colors`}
          >
            <img
              src={
                selected === "leaderboard"
                  ? "/manjumenuselectednew.png"
                  : "/manjumenuunselectednew.png"
              }
              alt="Leaderboard"
              className="h-14 w-14"
            />
            <span className="text-xs">Leaderboard</span>
          </button>

          <button
            onClick={() => {
              const audio = new Audio("/sounds/click.mp3");
              audio.play();
              handleFooterClick("bedtime-stories");
            }}
            className={`flex flex-col items-center ${
              selected === "entertainment" ? "text-green-600" : "text-gray-600"
            } transition-colors`}
          >
            <img
              src={
                selected === "bedtime"
                  ? "/robermenuselected.png"
                  : "/robertmenuunselected.png"
              }
              alt="Bedtime"
              className="h-14 w-14"
            />
            <span className="text-xs">Bedtime</span>
          </button>

          <button
            onClick={() => {
              const audio = new Audio("/sounds/click.mp3");
              audio.play();
              handleFooterClick("setting");
            }}
            className={`flex flex-col items-center ${
              selected === "learn" ? "text-pink-600" : "text-gray-600"
            } transition-colors`}
          >
            <img
              src={
                selected === "setting"
                  ? "/anjumenuunselectednew.png"
                  : "/anjumenuselectednew.png"
              }
              alt="Learn"
              className="h-14 w-14"
            />
            <span className="text-xs">Profile</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default SeriesScreen;
